import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 bg-white" data-id="element-124">
      <div className="max-w-3xl mx-auto px-4 text-center" data-id="element-125">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-tennis-green/5 border-2 border-tennis-green/20 rounded-3xl p-8 md:p-12 relative overflow-hidden" data-id="element-126">
          <div className="absolute top-0 right-0 -mr-10 -mt-10 text-tennis-green/10" data-id="element-127">
            <ShieldCheckIcon size={200} data-id="element-128" />
          </div>

          <div className="relative z-10" data-id="element-129">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-tennis-green text-white rounded-full mb-6 shadow-lg" data-id="element-130">
              <ShieldCheckIcon size={40} data-id="element-131" />
            </div>

            <h3 className="text-3xl md:text-4xl font-display text-charcoal mb-6" data-id="element-132">
              Garantía 7 días sin preguntas
            </h3>

            <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-133">
              Abrí los 12 Tomos. Revisá los 6 Bonus. Usá los Ebooks Elite en tu
              clase. Si no es lo que esperabas →{' '}
              <strong className="text-tennis-green" data-id="element-134">100% de devolución.</strong>{' '}
              Sin preguntas. Sin formularios. Sin drama.
            </p>

            <div className="inline-block bg-white border border-gray-200 px-6 py-3 rounded-full text-sm font-bold text-gray-500 tracking-wider shadow-sm" data-id="element-135">
              TASA DE DEVOLUCIONES MENOR AL 2%
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}